import api, { twUrl } from '../../utils/api';

class UtilService {
  /**
   * Get a long Url
   * @param shortUrl
   */
  static getLongUrl(shortUrl: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const apiResponse = api.post(twUrl.getLongUrl(), { url: shortUrl });

      apiResponse
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  }
}

export default UtilService;
